module.exports = __webpack_public_path__ + "media/Angela_Myers.10c96bf2.mp4";